export const SCREENS = {
  INITIAL: 'initScreen',
  CHAT_HISTORY: 'chatHistory',
};

export const SRC = {
  BOT: 'bot',
  CLIENT: ' client',
};

export const ACTIONS = {
  DIAGNOSTIC: 'diagnostic',
  EMAIL: 'email',
  DOMAIN_CONFIG: 'domainConfig',
  NEW_SITE: 'newSite',
};

export const WSS_ROUTES = {
  GENERAL: 'ai-agents/chat',
  DOMAIN: 'ai-agents/chat/domain',
  SITE: 'ai-agents/chat/site',
  EMAIL: 'ai-agents/chat/email',
  MARKETING: 'ai-agents/marketing',
};


export const DEVELOPMENT_ENV = {
  URL: 'https://redfish-up-kingfish.ngrok-free.app',
  WSS_URL: 'https://kingfish-calm-moose.ngrok-free.app',
};


export const INTERNAL_REDIRECT_OPTIONS = {
  BILLING: 'billing',
  INVOICES: 'invoices',
};


export const ALERTS_ACTIONS = {
  WEBSITE_IS_NOT_CREATED: 'website-not-created',
  CREATE_EMAIL: 'create-email',
  DOMAIN_IS_NOT_CONFIGURED: 'domain-not-configured',
  PENDING_ORDER: 'pending-order',
};
